"use client";

import { useSelection } from "@frend-digital/centra/client";
import { default as Script } from "next/script";

export const CentraCheckoutScript = () => {
  const { data } = useSelection();
  const script = data?.selection?.centraCheckoutScript;
  if (!script) return null;
  return (
    <Script
      id="centra-checkout-script"
      dangerouslySetInnerHTML={{
        __html: script,
      }}
    />
  );
};

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    CentraCheckout?: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      resume: (suspendIgnore?: Record<string, any>) => void;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      suspend: (suspendIgnore?: Record<string, any>) => void;

      reInitiate: (key: "ingrid") => void;

      destroy: () => void;
    };
  }
}

export const Centra = {
  resume: (suspendIgnore?: Record<string, unknown>) => {
    if (typeof window === "undefined") return;
    if (window.CentraCheckout) window.CentraCheckout.resume(suspendIgnore);
  },
  suspend: (suspendIgnore?: Record<string, unknown>) => {
    if (typeof window === "undefined") return;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.CentraCheckout) window.CentraCheckout.suspend(suspendIgnore);
  },
  reInitiate: (target: "ingrid") => {
    if (typeof window === "undefined") return;
    if (window.CentraCheckout) window.CentraCheckout.reInitiate(target);
  },
  destroy: () => {
    if (typeof window === "undefined") return;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.CentraCheckout) window.CentraCheckout.destroy();
  },
};
